<template>
	<div class="column is-multiline has-border-top is-padded-top is-padded-bottom is-mobile has-background-warning-080">
		<div class="has-box-shadow has-border has-background-white">
			<div class="columns">
				<!-- left column (icon)	-->
				<div class="column is-1 is-flex is-hidden-touch is-align-items-center is-align-content-center is-width-auto">
					<i class='fa-light fa-envelope fa-4x default-color' v-if="card.deliveryType === 'virtual'"></i>
					<i class='fa-light fa-truck-fast fa-4x default-color' v-else></i>
				</div>
				<div class="column is-flex is-hidden-desktop is-align-content-center">
					<i class='fa-light fa-envelope fa-2x default-color' v-if="card.deliveryType === 'virtual'"></i>
					<i class='fa-light fa-truck-fast fa-2x default-color' v-else></i>
				</div>
				<!-- right column -->
				<div class="columns column">
					<div class="column">
						<!-- header -->
						<div class="column is-paddingless-mobile">
							<p class="has-text-weight-semibold is-size-5-desktop is-size-6-tablet has-text-centered-mobile">
								{{ deliveryMessage }}
							</p>
						</div>
						<!-- message -->
						<div class="column">
							<div class="columns">
								<div class="column is-paddingless-mobile is-mobile has-text-centered-mobile is-flex-desktop">
									<p class="is-marged-right-desktop">
										{{ estimatedDeliveryDate }}
									</p>
									<a @click.prevent="showCardInfo">{{ cardsTranslations.banner.link }}</a>
									<card-info-popup
										v-if="showCard"
										@close-card="hideCardInfo"
										:closable="true"
										:card="card"
										:cards-translations="cardsTranslations"
										:no-address-label="noAddressLabel"
										:shipping-address-label="shippingAddressLabel"
										:shipping-email-label="shippingEmailLabel"/>
								</div>
							</div>
						</div>
					</div>
					<!-- on mobile view -->
					<div class="column is-hidden-desktop is-align-items-center">
						<div class="columns">
							<div v-if="card.isCardNeverReceived" class="column pb-1">
								<button class="button is-large is-fullwidth is-light is-size-5 track-action"
										@click="$emit('block-never-received-card')"
										data-ta-event="clientarea-track.employee.cards.card-not-received"
										data-ta-action="Click"
										data-ta-label="Employee-page - Cards – Click on Card not received button"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.card_not_received }}
								</button>
							</div>
							<div class="column" style="padding-top: 0.25rem !important" v-if="card.is_virtual">
								<button class="button is-large is-fullwidth is-success is-size-5 track-action"
										@click="$emit('resend-invitation-card')"
										data-ta-event="clientarea-track.employee.cards.card-activate"
										data-ta-action="Click"
										data-ta-label="Employee-page – Cards – Click on Card activate"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.resend_invitation }}
								</button>
							</div>
							<div class="column" style="padding-top: 0.25rem !important" v-else>
								<button class="button is-large is-fullwidth is-success is-size-5 track-action"
										@click="$emit('activate-card')"
										data-ta-event="clientarea-track.employee.cards.card-activate"
										data-ta-action="Click"
										data-ta-label="Employee-page – Cards – Click on Card activate"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.card_activate }}
								</button>
							</div>
						</div>
					</div>
					<!-- desktop view -->
					<div class="column is-flex is-two-fifths is-hidden-touch is-align-items-center is-justify-content-flex-end">
						<div class="columns">
							<div v-if="card.isCardNeverReceived" class="column pr-2">
								<button class="button is-medium is-light track-action"
										@click="$emit('block-card')"
										data-ta-event="clientarea-track.employee.cards.card-not-received"
										data-ta-action="Click"
										data-ta-label="Employee-page - Cards – Click on Card not received button"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.card_not_received }}
								</button>
							</div>
							<div class="column pl-2" v-if="card.is_virtual">
								<button class="button is-medium is-success track-action"
										@click="$emit('resend-invitation-card')"
										data-ta-event="clientarea-track.employee.cards.card-activate"
										data-ta-action="Click"
										data-ta-label="Employee-page – Cards – Click on Card resend invitation"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.resend_invitation }}
								</button>
							</div>
							<div class="column pl-2" v-else>
								<button class="button is-medium is-success track-action"
										@click="$emit('activate-card')"
										data-ta-event="clientarea-track.employee.cards.card-activate"
										data-ta-action="Click"
										data-ta-label="Employee-page – Cards – Click on Card activate"
										data-ta-page-name="EmployeeOverviewPage"
										:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
								>
									{{ cardsTranslations.banner.buttons.card_activate }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import date from "./mixins/dateFormatMixin";
export default {
	name: "delivery-banner",
	mixins: [date],
	props: {
		card: {type:Object, required:true},
		cardsTranslations: Object,
		noAddressLabel: String,
		shippingAddressLabel: {type:String, default:''},
		shippingEmailLabel: {type:String, default:''},
		userFirstName: {type:String, default:''},
	},
	data() {
		return {
			showCard: false,
		}
	},
	methods: {
		hideCardInfo() {
			this.showCard = false;
		},
		showCardInfo() {
			this.showCard = true;
		}
	},
	computed: {
		deliveryMessage() {
			return this.cardsTranslations.banner.message.replace(':firstname', this.userFirstName).replace(':card-number', this.card.number);
		},
		estimatedDeliveryDate() {
			if (this.card.deliveryType === 'virtual')
			{
				return this.cardsTranslations.banner.date_virtual.replace(':date', this.card.sending);
			}
			return this.card.estimated_delivery ?
				this.cardsTranslations.banner.date.replace(':date', this.card.estimated_delivery) :
				this.cardsTranslations.banner.date.replace(':date', this.cardsTranslations.date_coming_soon);
		}
	}
};
</script>
